import React, { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ExportProps } from "../../../../constants/reportConstant";
import { EmployeeApi } from "../../../../api/employee/employee.api";
import './print.style.css';
import DottedLine from "./DottedLine";
import { PositionApi } from "../../../../api/position/position.api";
import CheckBoxReport from "./CheckBoxReport";
import { accept_enum, accept_enum_three, accept_enum_two, category_address_enum, gender_enum, passed_the_military_data, personal_status_data, Rating } from "../enum/enum-personnel";
import moment from "moment";
import { getToken } from "../../../../utils/app.utils";

const FormPersonnelExport = () => {
    const { id, token } = useParams();
    const local_token: string | undefined | null = getToken();
    const api_path = process.env.REACT_APP_FILE_BASE_API
    const contentRef = useRef<HTMLDivElement | null>(null);
    const [detail, setDetail] = useState<any>(null);
    const [fileImagePath, setFileImagePath] = useState<string>("");

    const [position_name, set_position_name] = useState<string>("");

    const classNameCustom = {
        subText: 'mt-[-0.6rem]'
    }

    const handleGetPositionNameByPositionById = async (id_position: number) => {
        const response = await PositionApi.id(id_position);
        if (response.status > 300) {
            throw new Error("Error some thing wrong")
        }
        if (response.status < 300) {
            set_position_name(response.data?.data?.position_name || '');
        }
    }
    useEffect(() => {
        if (id && !isNaN(+id) && token) {
            const handleGetDetail = async () => {
                await EmployeeApi.getOneForExport(+id, local_token ? local_token : token).then(res => {
                    if (res.status < 300) {
                        setDetail(res.data?.data || null);
                        if (res.data?.data?.employee_image?.length > 0) {
                            setFileImagePath(res.data.data.employee_image[0]?.file_path || '')
                        }
                        if (res.data?.data.idposition) {
                            handleGetPositionNameByPositionById(res.data?.data?.idposition);
                        }
                    }
                }).catch((error) => {
                    console.log(error)
                })
            }
            handleGetDetail();
        }
    }, [])

    const ExportHeader = (page: string) => (
        <div className="w-full pdf-export-container">
            <div className="flex justify-between items-center w-full h-[5rem] border-[1px] border-black">
                {/* Your header content */}
                <section className="flex justify-center items-center px-3 py-1">
                    <article>
                        <img
                            src="/images/logo-mculg-custom-1.png"
                            width={77}
                            height={77}
                            alt="logo"
                        />
                    </article>
                </section>
                <section className="h-full flex flex-1 flex-col justify-around items-center border-[1px] border-b-0 border-t-0 border-black">
                    <article className="flex justify-center items-center h-full w-full text-xl text-center font-bold tracking-[0.5px]">
                        วิทยาลัยพุธศาสตร์นานาชาติ
                    </article>
                    <article className="flex justify-center items-center h-full w-full  border-b-[1px] border-black text-xl text-center font-bold tracking-[0.5px]">
                        มหาวิทยาลัยมหาจุฎาลงกรณราชวิทยาลัย
                    </article>
                    <article className="flex justify-center items-center h-full w-full border-b-0 border-black pb-2 text-xl text-center font-bold">
                        {/* เพื่อบรรจุและแต่งตั้งเป็นบุคลากร หรือแต่งตั้งเป็นลูกจ้างของมหาวิทยาลัย */}
                        ประวัติบุคลากร
                    </article>
                </section>
                <section className="h-full w-full max-w-[200px] flex flex-col justify-around items-center border-b-0 border-black">
                    <article className="flex justify-end px-1 items-center w-full h-full border-r-0 p-[0.14rem] border-black">
                        {/* <p className="text-[1rem] font-normal">เอกสารลำดับที่(ISO NO.)</p> */}
                        <p className="text-xl text-end font-normal">บค.02</p>
                    </article>
                    <article className="flex justify-between px-1 items-center w-full h-full border-r-0 border-black">
                        {/* <p className="text-[1rem] font-normal">ประกาศใช้เมื่อ(ISO Date)</p> */}
                    </article>
                    <article className="flex justify-between px-1 items-center w-full h-full border-r-0 border-black">
                        {/* <p className="text-[1rem] font-normal">ปรับปรุง(ISO Revision No.)</p> */}
                    </article>
                </section>
            </div>
            <section className="w-full flex justify-between items-center h-[2rem] border-[1px] border-[#000] border-t-0">
                <article className="px-4">
                    <p className="text-[1rem] font-normal">SRS_R008</p>
                </article>
                <article className="w-full max-w-[200px] flex justify-between px-[0.3rem] items-center">
                    {/* <span className="text-[1rem] font-normal">{`หน้าที่(Page)`}</span>
                    <span className="text-[1rem] font-normal">{page}</span> */}
                </article>
            </section>
        </div>
    );

    const PositionData = () => {
        return (
            <div className="col-span-12 mt-4">
                <section className="w-full flex flex-row">
                    <article className="w-full max-w-[60px] px-2 py-1 flex justify-center items-center flex-col border-[1px] border-black">
                        <span>ลำดับที่</span>
                        <span>RunNo.</span>
                    </article>
                    <article className="flex-1 px-2 py-1 border-l-0 flex justify-center items-center flex-col border-[1px] border-black">
                        <span>ตำแหน่งที่ต้องการ</span>
                        <span>Position Applied for</span>
                    </article>
                    <article className="flex-1 px-2 max-w-[200px] py-1 border-l-0 flex justify-center items-center flex-col border-[1px] border-black">

                    </article>
                </section>
                <section className="w-full flex flex-row">
                    {/* {positionData.map((list: any, index: number) => {
                        return ( */}
                    <React.Fragment>
                        <article className="w-full max-w-[60px] border-t-0 px-2 py-1 flex justify-center items-center flex-col border-[1px] border-black">
                            <p>{1}</p>
                        </article>
                        <article className="flex-1 px-2 py-1 border-t-0 border-l-0 flex justify-start items-center flex-col border-[1px] border-black">
                            <p>{position_name}</p>
                        </article>
                        <article className="flex-1 px-2  border-t-0 max-w-[200px] py-1 border-l-0 flex justify-center items-center flex-col border-[1px] border-black">
                            <p></p>
                        </article>
                    </React.Fragment>
                    {/* )
                    })} */}
                </section>
            </div>
        )
    }
    const PersonnelInformationData = () => {
        return (
            <React.Fragment>
                <article className="col-span-12 text-xl text-left font-bold tracking-[0.5px]">
                    {`Personal Information (ประวัติส่วนตัว)`}
                </article>
                <article className="col-span-12 border-[1px] border-[#000] h-full">
                    <div className="grid grid-cols-12 px-1 py-1">
                        <span className="col-span-4">
                            <DottedLine label="วัน เดือน ปีเกิด" detail={moment(detail?.date_of_birth).format("LL")} defaultLength={80} />
                        </span>
                        <span className="col-span-1">
                            <DottedLine label="อายุ" detail={`${moment().diff(detail?.date_of_birth, 'year')}` || ''} defaultLength={30} />
                        </span>
                        <span className="flex justify-center items-center text-[1rem] font-normal">
                            ปี
                        </span>
                    </div>
                    <div className={`grid grid-cols-12 px-1 py-1 ${classNameCustom.subText}`}>
                        <span className="col-span-4">
                            Date of Birth
                        </span>
                        <span className="col-span-1">
                            Age
                        </span>
                        <span className="flex justify-center items-center">
                            Yrs.
                        </span>
                    </div>
                    <div className="grid grid-cols-12 px-1 py-1 mt-[-0.5rem]">
                        <span className="col-span-4">
                            <DottedLine label="สถานที่เกิด" detail={detail?.place_of_birth || '-'} defaultLength={89} />
                        </span>
                        <span className="col-span-2">
                            <DottedLine label="จังหวัด" detail={detail?.province || '-'} defaultLength={70} />
                        </span>
                    </div>
                    <div className={`grid grid-cols-12 px-1 py-1 ${classNameCustom.subText}`}>
                        <span className="col-span-4">
                            Place
                        </span>
                        <span className="col-span-1">
                            Province
                        </span>
                    </div>
                    <div className="grid grid-cols-12 px-1 py-1 mt-[-0.5rem]">
                        <span className="col-span-4">
                            <DottedLine label="สัญชาติ" detail={detail?.nationality || '-'} defaultLength={97} />
                        </span>
                        <span className="col-span-3">
                            <DottedLine label="เชื้อชาติ" detail={detail?.race || '-'} defaultLength={68} />
                        </span>
                        <span className="col-span-2">
                            <DottedLine label="ศาสนา" detail={detail?.religion || '-'} defaultLength={70} />
                        </span>
                    </div>
                    <div className={`grid grid-cols-12 px-1 py-1 ${classNameCustom.subText}`}>
                        <span className="col-span-4">
                            Nationality
                        </span>
                        <span className="col-span-3">
                            Race
                        </span>
                        <span className="col-span-2">
                            Religion
                        </span>
                    </div>
                    <div className="grid grid-cols-12 px-1 py-1 mt-[-0.5rem]">
                        <span className="col-span-4">
                            <DottedLine label="บัตรประชาชนเลขที่" detail={detail?.idcard || '-'} defaultLength={73} />
                        </span>
                        <span className="col-span-3">
                            <DottedLine label="วันที่ออกบัตร" detail={moment(detail?.date_issue).add(543, 'year').format("LL") || '-'} defaultLength={57} />
                        </span>
                        <span className="col-span-3">
                            <DottedLine label="บัตรหมดอายุ" detail={moment(detail?.date_expiry).add(543, 'year').format("LL") || '-'} defaultLength={57} />
                        </span>
                    </div>
                    <div className={`grid grid-cols-12 px-1 py-1 ${classNameCustom.subText}`}>
                        <span className="col-span-4">
                            Identity card no.
                        </span>
                        <span className="col-span-3">
                            Issue Date
                        </span>
                        <span className="col-span-2">
                            Expiration date
                        </span>
                    </div>
                    <div className="grid grid-cols-12 px-1 py-1 mt-[-0.5rem]">
                        <span className="col-span-2">
                            <CheckBoxReport label="ภาวะทางทหาร" subLabel="Military Status" disableCheckBox />
                        </span>
                        <span className="col-span-2">
                            <CheckBoxReport checked={detail?.passed_the_military === passed_the_military_data.EXEMPT} label="ได้รับการยกเว้น" subLabel="Exempted" />
                        </span>
                        <span className="col-span-2">
                            <CheckBoxReport checked={detail?.passed_the_military === passed_the_military_data.MILITARY_SUBJECT} label="ศึกษาวิชาทหาร" subLabel="Defense Education" />
                        </span>
                        <span className="col-span-2">
                            <CheckBoxReport checked={detail?.passed_the_military === passed_the_military_data.PASSING_MILITARY} label="ผ่านการเกณฑ์ทหาร" subLabel="In Reserve" />
                        </span>
                    </div>
                    <div className="grid grid-cols-12 px-1 py-1 mt-[-0.5rem]">
                        <span className="col-span-2">
                            <CheckBoxReport label="สถานภาพ" subLabel="Marital status" disableCheckBox />
                        </span>
                        <span className="col-span-2">
                            <CheckBoxReport checked={detail?.personal_status === personal_status_data.SINGLE} label="โสด" subLabel="Single" />
                        </span>
                        <span className="col-span-2">
                            <CheckBoxReport checked={detail?.personal_status === personal_status_data.MARRIED} label="แต่งงาน" subLabel="Married" />
                        </span>
                        <span className="col-span-2">
                            <CheckBoxReport checked={detail?.personal_status === personal_status_data.WIDOWED} label="หม้าย" subLabel="Widowed" />
                        </span>
                        <span className="col-span-2">
                            <CheckBoxReport checked={detail?.personal_status === personal_status_data.DIVORCED} label="หย่า" subLabel="Divorced" />
                        </span>
                        <span className="col-span-2">
                            <CheckBoxReport checked={detail?.personal_status === personal_status_data.SEPARATED} label="แยกกัน" subLabel="Separated" />
                        </span>
                    </div>
                    <div className="grid grid-cols-12 px-1 py-1 mt-[-0.5rem]">
                        <span className="col-span-2">
                            <CheckBoxReport label="เพศ" subLabel="Sex" disableCheckBox />
                        </span>
                        <span className="col-span-2">
                            <CheckBoxReport checked={detail?.gender === gender_enum.MAN} label="ชาย" subLabel="Male" />
                        </span>
                        <span className="col-span-2">
                            <CheckBoxReport checked={detail?.gender === gender_enum.GIRL} label="หญิง" subLabel="Female" />
                        </span>
                    </div>
                </article>
            </React.Fragment>
        )
    }

    const AddressData = (address: any[]) => {
        const same_id_card_address = address?.find((x: any) => x?.id_address_type === 1) || null;
        const current_address = address?.find((x: any) => x?.id_address_type === 2) || null;
        const registration_address = address?.find((x: any) => x?.id_address_type === 5);


        const id_card_address_string: string = `${same_id_card_address?.house_number || ''} ${same_id_card_address?.moo || ''} ${same_id_card_address?.soi || ''} ${same_id_card_address?.road || ''} ${same_id_card_address?.district_sub || ''} ${same_id_card_address?.district || ''} ${same_id_card_address?.province || ''} ${same_id_card_address?.postcode || ''}`
        const current_address_string: string = `${current_address?.house_number || ''} ${current_address?.moo || ''} ${current_address?.soi || ''} ${current_address?.road || ''} ${current_address?.district_sub || ''} ${current_address?.district || ''} ${current_address?.province || ''} ${current_address?.postcode || ''}`
        const registration_address_string: string = `${registration_address?.house_number || ''} ${registration_address?.moo || ''} ${registration_address?.soi || ''} ${registration_address?.road || ''} ${registration_address?.district_sub || ''} ${registration_address?.district || ''} ${registration_address?.province || ''} ${registration_address?.postcode || ''}`
        return (
            <React.Fragment>
                <article className="col-span-12 text-xl text-left font-bold tracking-[0.5px]">
                    {`Address (ที่อยู่)`}
                </article>
                <article className="col-span-12 border-[1px] border-[#000] h-full">
                    {/* <div className="grid grid-cols-12 px-1 py-1">
                        <span className="col-span-12">
                            <DottedLine label="ที่อยู่ตามบัตรประชาชน" detail={id_card_address_string} defaultLength={330} />
                        </span>
                    </div>
                    <div className={`grid grid-cols-12 px-1 py-1 ${classNameCustom.subText}`}>
                        <span className="col-span-4">
                            ID Card address
                        </span>
                    </div>
                    <div className="grid grid-cols-12 px-1 py-1 mt-[-0.5rem]">
                        <span className="col-span-4">
                            <DottedLine label="โทรศัพท์" defaultLength={96} />
                        </span>
                        <span className="col-span-2">
                            <DottedLine label="มือถือ" defaultLength={70} />
                        </span>
                    </div>
                    <div className={`grid grid-cols-12 px-1 py-1 ${classNameCustom.subText}`}>
                        <span className="col-span-4">
                            Tel
                        </span>
                        <span className="col-span-1">
                            Mobile
                        </span>
                    </div>
                    <div className="grid grid-cols-12 px-1 py-1">
                        <span className="col-span-12">
                            <DottedLine label="ที่อยู่ตามทะเบียนบ้าน" detail={registration_address_string} defaultLength={332} />
                        </span>
                    </div>
                    <div className={`grid grid-cols-12 px-1 py-1 ${classNameCustom.subText}`}>
                        <span className="col-span-4">
                            Census records address
                        </span>
                    </div>
                    <div className="grid grid-cols-12 px-1 py-1 mt-[-0.5rem]">
                        <span className="col-span-4">
                            <DottedLine label="โทรศัพท์" defaultLength={96} />
                        </span>
                        <span className="col-span-2">
                            <DottedLine label="มือถือ" defaultLength={70} />
                        </span>
                    </div>
                    <div className={`grid grid-cols-12 px-1 py-1 ${classNameCustom.subText}`}>
                        <span className="col-span-4">
                            Tel
                        </span>
                        <span className="col-span-1">
                            Mobile
                        </span>
                    </div> */}
                    <div className="grid grid-cols-12 px-1 py-1">
                        <span className="col-span-12">
                            <DottedLine label="ที่อยู่ตามปัจจุบันเลขที่" detail={current_address_string} defaultLength={332} />
                        </span>
                    </div>
                    <div className={`grid grid-cols-12 px-1 py-1 ${classNameCustom.subText}`}>
                        <span className="col-span-4">
                            Present address
                        </span>
                    </div>
                    <div className="grid grid-cols-12 px-1 py-1 mt-[-0.5rem]">
                        <span className="col-span-4">
                            <DottedLine label="โทรศัพท์" defaultLength={96} />
                        </span>
                        <span className="col-span-2">
                            <DottedLine label="มือถือ" defaultLength={70} />
                        </span>
                    </div>
                    <div className={`grid grid-cols-12 px-1 py-1 ${classNameCustom.subText}`}>
                        <span className="col-span-4">
                            Tel
                        </span>
                        <span className="col-span-1">
                            Mobile
                        </span>
                    </div>
                    <div className="grid grid-cols-12 px-1 py-1 mt-[-0.5rem]">
                        <span className="col-span-4">
                            <DottedLine label="อีเมล" detail={detail?.email_personal || '-'} defaultLength={96} />
                        </span>
                    </div>
                    <div className={`grid grid-cols-12 px-1 py-1 ${classNameCustom.subText}`}>
                        <span className="col-span-4">
                            E-mail
                        </span>
                    </div>
                    {/* <div className="grid grid-cols-12 px-1 py-1 mt-[-0.5rem]">
                        <span className="col-span-1">
                        </span>
                        <span className="col-span-2">
                            <CheckBoxReport checked={current_address?.catagory_address === category_address_enum.PRIVATE_HOME} label="บ้านส่วนตัว" subLabel="Own home" />
                        </span>
                        <span className="col-span-2">
                            <CheckBoxReport checked={current_address?.catagory_address === category_address_enum.RENTAL_HOME} label="บ้านเช่า" subLabel="Hired hourse" />
                        </span>
                        <span className="col-span-2">
                            <CheckBoxReport checked={current_address?.catagory_address === category_address_enum.DORMITORY} label="หอพัก" subLabel="Hiredflat / Hostel" />
                        </span>
                        <span className="col-span-2">
                            <CheckBoxReport checked={current_address?.catagory_address === category_address_enum.RELATIVE} label="ญาติ" subLabel="With Relative" />
                        </span>
                        <span className="col-span-3">
                            <CheckBoxReport checked={current_address?.catagory_address === category_address_enum.TEMPLE_OR_FAMILY} label="วัดหรือ อยู่กับครอบครัว" subLabel="Temple or Living with parent" />
                        </span>
                    </div> */}
                </article>
            </React.Fragment>
        )
    }

    const parentData = () => {
        const parent_info: any = detail?.parent_info || null;
        return (
            <React.Fragment>
                <article className="col-span-12 text-xl text-left font-bold tracking-[0.5px]">
                    {`Family Information (ประวัติครอบครัว)`}
                </article>
                <article className="col-span-12 border-[1px] border-[#000] h-full">
                    <div className="grid grid-cols-12 px-1 py-1">
                        <span className="col-span-4">
                            <DottedLine label="บิดา ชื่อ - สกุล" detail={parent_info?.father_name || '-'} defaultLength={81} />
                        </span>
                        <span className="col-span-6">
                            <DottedLine label="อาชีพ" detail={parent_info?.father_occupation || '-'} defaultLength={70} />
                        </span>
                    </div>
                    <div className={`grid grid-cols-12 px-1 py-1 ${classNameCustom.subText}`}>
                        <span className="col-span-4">
                            Father's name - surname
                        </span>
                        <span className="col-span-1">
                            Occupation
                        </span>
                    </div>
                    <div className="grid grid-cols-12 px-1 py-1 mt-[-0.5rem]">
                        <span className="col-span-4">
                            <DottedLine label="สัญชาติ" detail={parent_info?.father_nationality || '-'} defaultLength={97} />
                        </span>
                    </div>
                    <div className={`grid grid-cols-12 px-1 py-1 ${classNameCustom.subText}`}>
                        <span className="col-span-4">
                            Nationality
                        </span>
                    </div>
                    <div className="grid grid-cols-12 px-1 py-1">
                        <span className="col-span-4">
                            <DottedLine label="มารดา ชื่อ - สกุล" detail={parent_info?.mother_name || '-'} defaultLength={76} />
                        </span>
                        <span className="col-span-6">
                            <DottedLine label="อาชีพ" detail={parent_info?.mother_occupation || '-'} defaultLength={70} />
                        </span>
                    </div>
                    <div className={`grid grid-cols-12 px-1 py-1 ${classNameCustom.subText}`}>
                        <span className="col-span-4">
                            Father's name - surname
                        </span>
                        <span className="col-span-1">
                            Occupation
                        </span>
                    </div>
                    <div className="grid grid-cols-12 px-1 py-1 mt-[-0.5rem]">
                        <span className="col-span-4">
                            <DottedLine label="สัญชาติ" detail={parent_info?.mother_nationality || '-'} defaultLength={97} />
                        </span>
                    </div>
                    <div className={`grid grid-cols-12 px-1 py-1 ${classNameCustom.subText}`}>
                        <span className="col-span-4">
                            Nationality
                        </span>
                    </div>
                    <div className="grid grid-cols-12 px-1 py-1 mt-[-0.5rem]">
                        <span className="col-span-4">
                            <DottedLine label="ภรรยา / สามี ชื่อ-สกุล" detail={parent_info?.spouse_name || '-'} defaultLength={65} />
                        </span>
                        <span className="col-span-3">
                            <DottedLine label="อาชีพ" detail={parent_info?.spouse_occupation || '-'} defaultLength={70} />
                        </span>
                        <span className="col-span-3">
                            <DottedLine label="สถานที่ทำงาน" detail={parent_info?.spouse_work_place || '-'} defaultLength={57} />
                        </span>
                    </div>
                    <div className={`grid grid-cols-12 px-1 py-1 ${classNameCustom.subText}`}>
                        <span className="col-span-4">
                            Name of wife / Husband
                        </span>
                        <span className="col-span-3">
                            Occupation
                        </span>
                        <span className="col-span-2">
                            Working place
                        </span>
                    </div>
                    <div className="grid grid-cols-12 px-1 py-1">
                        <span className="col-span-4">
                            <DottedLine label="นามสกุลเดิมคู่สมรส" detail={parent_info?.spouse_last_name || '-'} defaultLength={72} />
                        </span>
                        <span className="col-span-3">
                            <DottedLine label="สัญชาติคู่สมรส" detail={parent_info?.spouse_nationality || '-'} defaultLength={70} />
                        </span>
                    </div>
                    <div className={`grid grid-cols-12 px-1 py-1 ${classNameCustom.subText}`}>
                        <span className="col-span-4">
                            Maiden Name
                        </span>
                        <span className="col-span-1">
                            Nationality
                        </span>
                    </div>
                    <div className="grid grid-cols-12 px-1 py-1">
                        <span className="col-span-4">
                            <DottedLine label="เลขบัตรประชาชนคู่สมรส" detail={parent_info?.spouse_idcard || '-'} defaultLength={60} />
                        </span>
                        <span className="col-span-4">
                            <DottedLine label="วันเกิดคู่สมรส" detail={moment(parent_info?.spouse_birthday).format("LL") || '-'} defaultLength={70} />
                        </span>
                    </div>
                    <div className={`grid grid-cols-12 px-1 py-1 ${classNameCustom.subText}`}>
                        <span className="col-span-4">
                            Identity card no
                        </span>
                        <span className="col-span-1">
                            Date of birth
                        </span>
                    </div>
                    <div className="grid grid-cols-12 px-1 py-1">
                        <span className="col-span-1">
                            <DottedLine label="มีบุตร" detail={`${parent_info?.child_qty}` || '-'} detailCenter defaultLength={23} />
                        </span>
                        <span className="col-span-1 text-[1rem] font-normal flex justify-center items-center">คน</span>
                    </div>
                    <div className={`grid grid-cols-12 px-1 py-1 ${classNameCustom.subText}`}>
                        <span className="col-span-4">
                            Number of children
                        </span>
                    </div>
                </article>
            </React.Fragment>
        )
    }
    const siblingsData = (siblings_data: any[]) => {
        return (
            <React.Fragment>
                <article className="mx-2 col-span-12 text-xl text-left font-bold tracking-[0.5px]">
                    {`Siblings (ข้อมูลพี่น้อง)`}
                </article>
                <div className="mx-2 col-span-12 border-[1px] border-[#000]">
                    <article className="grid grid-cols-12">
                        <span className="col-span-4 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="ชื่อ - สกุล"
                                disableCheckBox subLabel="Name - Last Name"
                            />
                        </span>
                        <span className="col-span-1 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="อายุ (ปี)"
                                disableCheckBox subLabel="Age"
                            />
                        </span>
                        <span className="col-span-3 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="อาชีพ"
                                disableCheckBox subLabel="Occupation"
                            />
                        </span>
                        <span className="col-span-4 flex justify-center items-center">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="สถานที่ทำงาน"
                                disableCheckBox subLabel="Work Place"
                            />
                        </span>
                    </article>
                    <article className="grid grid-cols-12">
                        {siblings_data.map((list: any) => {
                            return (
                                <>
                                    <span className="col-span-4 py-1 px-2 border-t-[1px] border-black border-r-[1px]">{list.siblings_name || '-'}</span>
                                    <span className="col-span-1 py-1 text-center border-t-[1px] border-black border-r-[1px]">{list.siblings_old || "-"}</span>
                                    <span className="col-span-3 py-1 px-2 border-t-[1px] border-black border-r-[1px]">{list.siblings_occupation || '-'}</span>
                                    <span className="col-span-4 py-1 px-2 border-t-[1px] border-black">{list.siblings_workplace || '-'}</span>
                                </>
                            )
                        })}
                    </article>
                </div>

            </React.Fragment>
        )
    }
    const EmploymentHistoryData = (work_history: any) => {
        // console.log(work_history)
        const work_history_data: any[] = work_history?.work_history_data || [];
        return (
            <div className={`${work_history_data.length > 3 && 'page-break'} col-span-12 overflow-hidden mx-2`}>
                <article className="w-full text-xl text-left font-bold tracking-[0.5px]">
                    {`Employment History (ประวัติการทำงาน)`}
                </article>
                <div className="w-full border-[1px] border-[#000]">
                    <article className="grid grid-cols-12">
                        <span className="col-span-4 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="ชื่อสถานประกอบการ"
                                disableCheckBox subLabel="Company"
                            />
                        </span>
                        <span className="col-span-4 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="ระยะเวลา"
                                disableCheckBox subLabel="Time"
                            />
                        </span>
                        <span className="col-span-4 flex justify-center items-center border-[#000]">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="จำนวนเดือนที่ทำงาน"
                                disableCheckBox subLabel="Month Work"
                            />
                        </span>
                        {/* <span className="col-span-2 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="ตำแหน่งงาน"
                                disableCheckBox subLabel="Position"
                            />
                        </span>
                        <span className="col-span-2 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="เงินเดือน"
                                disableCheckBox subLabel="Salary"
                            />
                        </span>
                        <span className="col-span-2 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="รายได้อื่นๆ"
                                disableCheckBox subLabel="OtherIncome"
                            />
                        </span>
                        <span className="col-span-2 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="เหตุผลที่ออก"
                                disableCheckBox subLabel="Resign Reason"
                            />
                        </span>
                        <span className="col-span-1 flex justify-center items-center">
                            <CheckBoxReport
                                labelClassName="text-center flex justify-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="ติดต่อได้"
                                disableCheckBox subLabel="Can Contact"
                            />
                        </span> */}
                    </article>
                    <article className="grid grid-cols-12">
                        {work_history_data.map((list: any, index: number) => {
                            const dateStart = moment(list?.date_start_work);
                            const dateEnd = moment(list?.date_end_work);
                            const monthsDifference = dateEnd.diff(dateStart, 'months');
                            return (
                                <React.Fragment key={index}>
                                    <span className="col-span-4 border-t-[1px] border-black border-r-[1px] text-center flex justify-center items-center">
                                        {list?.company || '-'}
                                    </span>
                                    <span className="col-span-4 border-t-[1px] border-black border-r-[1px]">
                                        <div className="border-b-[1px] border-black px-1">
                                            <CheckBoxReport
                                                labelClassName="text-center"
                                                subLabelClassName="mt-[-0.3rem] text-start"
                                                label="จาก"
                                                disableCheckBox
                                                subLabel="From"
                                                detailLabel={list?.date_start_work ? `${moment(list?.date_start_work).add(543, 'year').format("LL")}` : "-"}
                                            />
                                            <CheckBoxReport
                                                labelClassName="text-center"
                                                subLabelClassName="mt-[-0.3rem] text-start"
                                                label="ถึง"
                                                disableCheckBox
                                                subLabel="To"
                                                detailLabel={list?.date_end_work ? `${moment(list?.date_end_work).add(543, 'year').format("LL")}` : '-'}
                                            />
                                        </div>
                                        <div className="px-1">
                                            <CheckBoxReport
                                                labelClassName="text-center"
                                                subLabelClassName="mt-[-0.3rem] text-start"
                                                label="เบอร์ติดต่อ"
                                                disableCheckBox subLabel="Tel."
                                                detailLabel={list?.work_contact || '-'}
                                            />
                                        </div>
                                    </span>
                                    <span className="col-span-4 border-t-[1px] border-black flex justify-center items-center">
                                        {monthsDifference || '-'}
                                    </span>
                                    {/* <span className="col-span-2 border-t-[1px] border-black border-r-[1px] flex flex-col">
                                        <div className="flex flex-col justify-center items-center border-b-[1px] border-black h-full">
                                            <CheckBoxReport
                                                labelClassName="text-center"
                                                subLabelClassName="mt-[-0.3rem] text-start flex justify-center"
                                                label="ตำแหน่งงาน(เริ่มต้น)"
                                                disableCheckBox
                                                subLabel="Position Start"
                                            />
                                            <span>
                                                {list?.position_start || '-'}
                                            </span>
                                        </div>
                                        <div className="flex flex-col justify-center items-center h-full">
                                            <CheckBoxReport
                                                labelClassName="text-center"
                                                subLabelClassName="mt-[-0.3rem] text-start flex justify-center"
                                                label="ตำแหน่งงาน(สิ้นสุด)"
                                                disableCheckBox
                                                subLabel="Position End"
                                            />
                                            <span>
                                                {list?.position_end || '-'}
                                            </span>
                                        </div>
                                    </span>
                                    <span className="col-span-2 flex flex-col border-t-[1px] border-black border-r-[1px]">
                                        <div className="flex flex-col justify-center items-center border-b-[1px] border-black h-full">
                                            <CheckBoxReport
                                                labelClassName="text-center"
                                                subLabelClassName="mt-[-0.3rem] text-start flex justify-center"
                                                label="เงินเดือน(เริ่มต้น)"
                                                disableCheckBox
                                                subLabel="Salary Start"
                                            />
                                            <span>
                                                {Number(list?.salary_start || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '-'}
                                            </span>
                                        </div>
                                        <div className="flex flex-col justify-center items-center h-full">
                                            <CheckBoxReport
                                                labelClassName="text-center"
                                                subLabelClassName="mt-[-0.3rem] text-start flex justify-center"
                                                label="เงินเดือน(สิ้นสุด)"
                                                disableCheckBox
                                                subLabel="Salary End"
                                            />
                                            <span>
                                                {Number(list?.salary_end || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '-'}
                                            </span>
                                        </div>
                                    </span>
                                    <span className="col-span-2 border-t-[1px] border-black border-r-[1px] flex justify-center items-center">
                                        {Number(list?.income_other || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </span>
                                    <span className="col-span-2 border-t-[1px] border-black border-r-[1px] flex justify-center items-center">
                                        {list?.reason_for_leaving || '-'}
                                    </span>
                                    <span className="col-span-1 border-t-[1px] border-black pt-3">
                                        <CheckBoxReport checked={list?.work_contact_status === accept_enum.YES} align="center" disabledLabel label="" />
                                    </span> */}
                                </React.Fragment>
                            )
                        })}
                    </article>
                </div>
            </div>
        )
    }
    const EducationData = (education_data: any[]) => {
        return (
            <div className="col-span-12">
                <article className="mx-2 col-span-12 text-xl text-left font-bold tracking-[0.5px]">
                    {`Education Background (ประวัติการศึกษา)`}
                </article>
                <div className="mx-2 col-span-12 border-[1px] border-[#000]">
                    <article className="grid grid-cols-16">
                        <span className="col-span-2 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="ระดับการศึกษา"
                                disableCheckBox subLabel="Education Level"
                            />
                        </span>
                        <span className="col-span-2 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="วุฒิการศึกษา"
                                disableCheckBox subLabel="Education Degree"
                            />
                        </span>
                        <span className="col-span-3 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="สถาบันการศึกษา"
                                disableCheckBox subLabel="Institution"
                            />
                        </span>
                        <span className="col-span-3 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="หลักสูตร"
                                disableCheckBox subLabel="Facuty"
                            />
                        </span>
                        <span className="col-span-2 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="ปีที่สำเร็จการศึกษา"
                                disableCheckBox subLabel="Graduade Year"
                            />
                        </span>
                        <span className="col-span-2 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="วิชาเอก"
                                disableCheckBox subLabel="Major"
                            />
                        </span>
                        <span className="col-span-2 flex justify-center items-center">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="วิชาโท"
                                disableCheckBox subLabel="Minor"
                            />
                        </span>
                    </article>
                    <article className="grid grid-cols-16 text-center">
                        {education_data.map((list: any) => {
                            return (
                                <>
                                    <span className="col-span-2 py-1 px-2 border-t-[1px] border-black border-r-[1px]">{list.education_type?.education_type_name || '-'}</span>
                                    <span className="col-span-2 py-1 text-center border-t-[1px] border-black border-r-[1px]">{list.certificate || "-"}</span>
                                    <span className="col-span-3 py-1 px-2 border-t-[1px] border-black border-r-[1px]">{list?.educational_institutions || '-'}</span>
                                    <span className="col-span-3 py-1 px-2 border-t-[1px] border-black border-r-[1px]">{list.faculty || '-'}</span>
                                    <span className="col-span-2 py-1 px-2 border-t-[1px] border-black border-r-[1px]">{list?.date_end_study ? moment(list?.date_end_study).format("YYYY") : '-'}</span>
                                    <span className="col-span-2 py-1 px-2 border-t-[1px] border-black border-r-[1px]">{list?.major || "-"}</span>
                                    <span className="col-span-2 py-1 px-2 border-t-[1px] border-black">{list.minor || '-'}</span>
                                </>
                            )
                        })}
                    </article>
                </div>
            </div>
        )
    }
    const traningData = (training_data: any[]) => {
        return (
            <div className="col-span-12">
                <article className="mx-2 col-span-12 text-xl text-left font-bold tracking-[0.5px]">
                    {`Activities/Job Training (กิจกรรมหรือการอบรม ในช่วงระหว่างการศึกษา/ระหว่างทำงาน)`}
                </article>
                <div className="mx-2 col-span-12 border-[1px] border-[#000]">
                    <article className="grid grid-cols-12">
                        <span className="col-span-2 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="ปีที่อบรม"
                                disableCheckBox subLabel="Train Year"
                            />
                        </span>
                        <span className="col-span-4 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="ชื่อสถาบัน"
                                disableCheckBox subLabel="Institution"
                            />
                        </span>
                        <span className="col-span-4 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="ชื่อหลักสูตร"
                                disableCheckBox subLabel="Course Name"
                            />
                        </span>
                        <span className="col-span-2 flex justify-center items-center border-[#000]">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="ระยะเวลาที่อบรม"
                                disableCheckBox subLabel="Period of Train"
                            />
                        </span>
                    </article>
                    <article className="grid grid-cols-12 text-center">
                        {training_data.map((list: any) => {
                            return (
                                <>
                                    <span className="col-span-2 py-1 px-2 border-t-[1px] border-black border-r-[1px]">{list.training_year || '-'}</span>
                                    <span className="col-span-4 py-1 text-center border-t-[1px] border-black border-r-[1px]">{list.training_organization || "-"}</span>
                                    <span className="col-span-4 py-1 px-2 border-t-[1px] border-black border-r-[1px]">{list.training_name || '-'}</span>
                                    <span className="col-span-2 py-1 px-2 border-t-[1px] border-black">{list?.training_duration && list?.duration_format ? `${list?.training_duration} ${list?.duration_format}` : '-'}</span>
                                </>
                            )
                        })}
                    </article>
                </div>
            </div>
        )
    }
    const languageData = (language_data: any[]) => {
        return (
            <div className="col-span-12">
                <article className="mx-2 col-span-12 text-xl text-left font-bold tracking-[0.5px]">
                    {`Language Ability (ความสามารถทางภาษา)`}
                </article>
                <div className="mx-2 col-span-12 border-[1px] border-[#000]">
                    <article className="grid grid-cols-14">
                        <span className="col-span-2 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center flex justify-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="ภาษา"
                                disableCheckBox subLabel="Language"
                            />
                        </span>
                        <span className="col-span-3 flex flex-col justify-center items-center border-[#000] border-r-[1px]">
                            <span className="w-full flex justify-center border-b-[1px] border-black">
                                <CheckBoxReport
                                    labelClassName="text-center"
                                    subLabelClassName="mt-[-0.3rem] text-center"
                                    label="พูด (Speaking)"
                                    disableCheckBox
                                />
                            </span>
                            <span className="w-full grid grid-cols-16">
                                <div className="text-center flex justify-center items-center col-span-5 border-r-[1px] border-black"><CheckBoxReport labelClassName="flex justify-center" disableCheckBox label="ดีมาก" subLabel="Excellent" /></div>
                                <div className="text-center flex justify-center items-center col-span-3 border-r-[1px] border-black"><CheckBoxReport labelClassName="flex justify-center" disableCheckBox label="ดี" subLabel="Good" /></div>
                                <div className="text-center flex justify-center items-center col-span-5 border-r-[1px] border-black"><CheckBoxReport labelClassName="flex justify-center" disableCheckBox label="ปานกลาง" subLabel="Fair" /></div>
                                <div className="text-center flex justify-center items-center col-span-3"><CheckBoxReport disableCheckBox label="พอใช้" subLabel="Poor" /></div>
                            </span>
                        </span>
                        <span className="col-span-3 flex flex-col justify-center items-center border-[#000] border-r-[1px]">
                            <span className="w-full flex justify-center border-b-[1px] border-black">
                                <CheckBoxReport
                                    labelClassName="text-center"
                                    subLabelClassName="mt-[-0.3rem] text-center"
                                    label="เขียน (Writing)"
                                    disableCheckBox
                                />
                            </span>
                            <span className="w-full grid grid-cols-16">
                                <div className="text-center flex justify-center items-center col-span-5 border-r-[1px] border-black"><CheckBoxReport labelClassName="flex justify-center" disableCheckBox label="ดีมาก" subLabel="Excellent" /></div>
                                <div className="text-center flex justify-center items-center col-span-3 border-r-[1px] border-black"><CheckBoxReport labelClassName="flex justify-center" disableCheckBox label="ดี" subLabel="Good" /></div>
                                <div className="text-center flex justify-center items-center col-span-5 border-r-[1px] border-black"><CheckBoxReport labelClassName="flex justify-center" disableCheckBox label="ปานกลาง" subLabel="Fair" /></div>
                                <div className="text-center flex justify-center items-center col-span-3"><CheckBoxReport disableCheckBox label="พอใช้" subLabel="Poor" /></div>
                            </span>
                        </span>
                        <span className="col-span-3 flex flex-col justify-center items-center border-[#000] border-r-[1px]">
                            <span className="w-full flex justify-center border-b-[1px] border-black">
                                <CheckBoxReport
                                    labelClassName="text-center"
                                    subLabelClassName="mt-[-0.3rem] text-center"
                                    label="อ่าน (Reading)"
                                    disableCheckBox
                                />
                            </span>
                            <span className="w-full h-full grid grid-cols-16">
                                <div className="text-center flex justify-center items-center col-span-5 border-r-[1px] border-black"><CheckBoxReport labelClassName="flex justify-center" disableCheckBox label="ดีมาก" subLabel="Excellent" /></div>
                                <div className="text-center flex justify-center items-center col-span-3 border-r-[1px] border-black"><CheckBoxReport labelClassName="flex justify-center" disableCheckBox label="ดี" subLabel="Good" /></div>
                                <div className="text-center flex justify-center items-center col-span-5 border-r-[1px] border-black"><CheckBoxReport labelClassName="flex justify-center" disableCheckBox label="ปานกลาง" subLabel="Fair" /></div>
                                <div className="text-center flex justify-center items-center col-span-3"><CheckBoxReport disableCheckBox label="พอใช้" subLabel="Poor" /></div>
                            </span>
                        </span>
                        <span className="col-span-3 flex flex-col justify-center items-center border-[#000]">
                            <span className="w-full flex justify-center border-b-[1px] border-black">
                                <CheckBoxReport
                                    labelClassName="text-center"
                                    subLabelClassName="mt-[-0.3rem] text-center"
                                    label="พิมพ์ (Typing)"
                                    disableCheckBox
                                />
                            </span>
                            <span className="w-full h-full grid grid-cols-16">
                                <div className="text-center flex justify-center items-center col-span-5 border-r-[1px] border-black"><CheckBoxReport labelClassName="flex justify-center" disableCheckBox label="ดีมาก" subLabel="Excellent" /></div>
                                <div className="text-center flex justify-center items-center col-span-3 border-r-[1px] border-black"><CheckBoxReport labelClassName="flex justify-center" disableCheckBox label="ดี" subLabel="Good" /></div>
                                <div className="text-center flex justify-center items-center col-span-5 border-r-[1px] border-black"><CheckBoxReport labelClassName="flex justify-center" disableCheckBox label="ปานกลาง" subLabel="Fair" /></div>
                                <div className="text-center flex justify-center items-center col-span-3"><CheckBoxReport disableCheckBox label="พอใช้" subLabel="Poor" /></div>
                            </span>
                        </span>
                    </article>
                    <article className="grid grid-cols-14 text-center">
                        {language_data.map((list: any) => {
                            return (
                                <>
                                    <span className="col-span-2 py-1 px-2 border-t-[1px] border-black border-r-[1px]">{list.language_name || '-'}</span>
                                    <span className="col-span-3 h-full text-center border-t-[1px] border-black border-r-[1px]">
                                        <span className="w-full h-full grid grid-cols-16">
                                            <div className="text-center flex justify-center items-center col-span-5 border-r-[1px] border-black"><CheckBoxReport checked={list.level_speaking === Rating.BEST} align="center" disabledLabel label="" /></div>
                                            <div className="text-center flex justify-center items-center col-span-3 border-r-[1px] border-black"><CheckBoxReport checked={list.level_speaking === Rating.GOOD} align="center" disabledLabel label="" /></div>
                                            <div className="text-center flex justify-center items-center col-span-5 border-r-[1px] border-black"><CheckBoxReport checked={list.level_speaking === Rating.FAIR} align="center" disabledLabel label="" /></div>
                                            <div className="text-center flex justify-center items-center col-span-3"><CheckBoxReport checked={list.level_speaking === Rating.BAD} align="center" disabledLabel label="" /></div>
                                        </span>
                                    </span>
                                    <span className="col-span-3 h-full text-center border-t-[1px] border-black border-r-[1px]">
                                        <span className="w-full h-full grid grid-cols-16">
                                            <div className="text-center flex justify-center items-center col-span-5 border-r-[1px] border-black"><CheckBoxReport checked={list.level_writing === Rating.BEST} align="center" disabledLabel label="" /></div>
                                            <div className="text-center flex justify-center items-center col-span-3 border-r-[1px] border-black"><CheckBoxReport checked={list.level_writing === Rating.GOOD} align="center" disabledLabel label="" /></div>
                                            <div className="text-center flex justify-center items-center col-span-5 border-r-[1px] border-black"><CheckBoxReport checked={list.level_writing === Rating.FAIR} align="center" disabledLabel label="" /></div>
                                            <div className="text-center flex justify-center items-center col-span-3"><CheckBoxReport checked={list.level_writing === Rating.BAD} align="center" disabledLabel label="" /></div>
                                        </span>
                                    </span>
                                    <span className="col-span-3 h-full text-center border-t-[1px] border-black border-r-[1px]">
                                        <span className="w-full h-full grid grid-cols-16">
                                            <div className="text-center flex justify-center items-center col-span-5 border-r-[1px] border-black"><CheckBoxReport checked={list.level_reading === Rating.BEST} align="center" disabledLabel label="" /></div>
                                            <div className="text-center flex justify-center items-center col-span-3 border-r-[1px] border-black"><CheckBoxReport checked={list.level_reading === Rating.GOOD} align="center" disabledLabel label="" /></div>
                                            <div className="text-center flex justify-center items-center col-span-5 border-r-[1px] border-black"><CheckBoxReport checked={list.level_reading === Rating.FAIR} align="center" disabledLabel label="" /></div>
                                            <div className="text-center flex justify-center items-center col-span-3"><CheckBoxReport checked={list.level_reading === Rating.BAD} align="center" disabledLabel label="" /></div>
                                        </span>
                                    </span>
                                    <span className="col-span-3 h-full text-center border-t-[1px] border-black">
                                        <span className="w-full h-full grid grid-cols-16">
                                            <div className="text-center flex justify-center items-center col-span-5 border-r-[1px] border-black"><CheckBoxReport checked={list.level_printing === Rating.BEST} align="center" disabledLabel label="" /></div>
                                            <div className="text-center flex justify-center items-center col-span-3 border-r-[1px] border-black"><CheckBoxReport checked={list.level_printing === Rating.GOOD} align="center" disabledLabel label="" /></div>
                                            <div className="text-center flex justify-center items-center col-span-5 border-r-[1px] border-black"><CheckBoxReport checked={list.level_printing === Rating.FAIR} align="center" disabledLabel label="" /></div>
                                            <div className="text-center flex justify-center items-center col-span-3"><CheckBoxReport checked={list.level_printing === Rating.BAD} align="center" disabledLabel label="" /></div>
                                        </span>
                                    </span>
                                </>
                            )
                        })}
                    </article>
                </div>
            </div>
        )
    }
    const otherAbilityData = (ability_data: any[]) => {
        return (
            <div className="col-span-12">
                <article className="mx-2 col-span-12 text-xl text-left font-bold tracking-[0.5px]">
                    {`Other Ability (ความสามารถอื่นๆ)`}
                </article>
                <div className="mx-2 col-span-12 border-[1px] border-[#000]">
                    <article className="grid grid-cols-16">
                        <span className="col-span-8 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="ทักษะ/ความสามารถอื่นๆ"
                                disableCheckBox subLabel="Other Skill"
                            />
                        </span>
                        <span className="col-span-2 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center flex justify-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="ดีมาก"
                                disableCheckBox subLabel="Excellent"
                            />
                        </span>
                        <span className="col-span-2 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center flex justify-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="ดี"
                                disableCheckBox subLabel="Good"
                            />
                        </span>
                        <span className="col-span-2 flex justify-center items-center border-[#000] border-r-[1px]">
                            <CheckBoxReport
                                labelClassName="text-center flex justify-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="ปานกลาง"
                                disableCheckBox subLabel="Fair"
                            />
                        </span>
                        <span className="col-span-2 flex justify-center items-center">
                            <CheckBoxReport
                                labelClassName="text-center flex justify-center"
                                subLabelClassName="mt-[-0.3rem] text-center"
                                label="พอใช้"
                                disableCheckBox subLabel="Poor"
                            />
                        </span>
                    </article>
                    <article className="grid grid-cols-16 text-center">
                        {ability_data.map((list: any) => {
                            return (
                                <>
                                    <span className="col-span-8 py-1 px-2 border-t-[1px] border-black border-r-[1px]">{list.abilities_name || '-'}</span>
                                    <span className="col-span-2 py-1 text-center border-t-[1px] border-black border-r-[1px]">
                                        <CheckBoxReport label="" checked={list.level_abilities === Rating.BEST} disabledLabel containerClassName="flex justify-center items-center" />
                                    </span>
                                    <span className="col-span-2 py-1 px-2 border-t-[1px] border-black border-r-[1px]">
                                        <CheckBoxReport label="" checked={list.level_abilities === Rating.GOOD} disabledLabel containerClassName="flex justify-center items-center" />
                                    </span>
                                    <span className="col-span-2 py-1 px-2 border-t-[1px] border-black border-r-[1px]">
                                        <CheckBoxReport label="" checked={list.level_abilities === Rating.FAIR} disabledLabel containerClassName="flex justify-center items-center" />
                                    </span>
                                    <span className="col-span-2 py-1 px-2 border-t-[1px] border-black">
                                        <CheckBoxReport label="" checked={list.level_abilities === Rating.BAD} disabledLabel containerClassName="flex justify-center items-center" />
                                    </span>
                                </>
                            )
                        })}
                    </article>
                </div>
            </div>
        )
    }
    const additionalInformation = (data: any, emergency_data: any) => {
        const driving_data = data?.driving_skills || null;
        const work_other_province = data?.work_other_province || null;
        const work_abroad = data?.work_abroad || null;
        const work_shifts = data?.work_shifts || "";
        const serious_injury = data?.serious_injury || null;
        const congenital_disease = data?.congenital_disease || null;
        const employee_in_company = data?.employee_in_company || null;
        const relatives_work_company = data?.relatives_work_company || null;
        const criminal_penalty = data?.criminal_penalty || null;
        return (
            <div className="col-span-12">
                <span className="w-full">
                    <CheckBoxReport
                        label="ความสามารถในการขับขี่"
                        subLabel="Can Operate Vehicle"
                        labelBolder
                        disableCheckBox
                    />
                </span>
                <span className="grid grid-cols-12">
                    <div className="col-span-3"></div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            label="มีความสามารถในการขับขี่"
                            subLabel="Can Drive"
                            disableCheckBox
                        />
                    </div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            label="มีใบขับขี่"
                            subLabel="Process License"
                            disableCheckBox
                        />
                    </div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            label="มีรถส่วนตัว"
                            subLabel="Process"
                            disableCheckBox
                        />
                    </div>
                </span>
                <span className="grid grid-cols-12 mt-2">
                    <div className="col-span-3 text-[1rem]">
                        รถยนต์ / Car
                    </div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            checked={!!driving_data?.can_drive_car}
                            label=""
                            disabledLabel
                            align="center"
                        />
                    </div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            checked={!!driving_data?.have_license_car}
                            label=""
                            disabledLabel
                            align="center"
                        />
                    </div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            checked={!!driving_data?.have_car}
                            label=""
                            disabledLabel
                            align="center"
                        />
                    </div>
                </span>
                <span className="grid grid-cols-12 mt-1">
                    <div className="col-span-3 text-[1rem]">
                        รถจักรยานยนต์ / MotorCycle
                    </div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            checked={!!driving_data?.can_drive_motorcycle}
                            label=""
                            disabledLabel
                            align="center"
                        />
                    </div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            checked={!!driving_data?.have_license_motorcycle}
                            label=""
                            disabledLabel
                            align="center"
                        />
                    </div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            checked={!!driving_data?.have_motorcycle}
                            label=""
                            disabledLabel
                            align="center"
                        />
                    </div>
                </span>
                <span className="grid grid-cols-12 mt-2">
                    <div className="col-span-12">
                        <DottedLine
                            label="ประสบการณ์ / Experience"
                            defaultLength={220}
                        />
                    </div>
                </span>
                <span className="w-full">
                    <CheckBoxReport
                        label="ท่านสามารถไปปฏิบัติงานต่างจังหวัดได้หรือไม่"
                        subLabel="Willing to work the provinces ?"
                        labelBolder
                        disableCheckBox
                    />
                </span>
                <span className="grid grid-cols-12 mt-1">
                    <div className="col-span-2 text-[1rem]">
                        -แบบประจำ / Permanent
                    </div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            checked={work_other_province?.work_other_provinces_regularly === accept_enum.NO}
                            label="ไม่ได้"
                            subLabel="No"
                            align="center"
                        />
                    </div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            checked={work_other_province?.work_other_provinces_regularly === accept_enum.YES}
                            label="ได้"
                            subLabel="Yes"
                            align="center"
                        />
                    </div>
                </span>
                <span className="grid grid-cols-12 mt-1">
                    <div className="col-span-2 text-[1rem]">
                        -แบบชั่วคราว / Temporary
                    </div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            checked={work_other_province?.work_other_provinces_temporarily === accept_enum.NO}
                            label="ไม่ได้"
                            subLabel="No"
                            align="center"
                        />
                    </div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            checked={work_other_province?.work_other_provinces_temporarily === accept_enum.YES}
                            label="ได้"
                            subLabel="Yes"
                            align="center"
                        />
                    </div>
                </span>
                <span className="w-full">
                    <CheckBoxReport
                        label="ท่านสามารถไปปฏิบัติงานต่างประเทศได้หรือไม่"
                        subLabel="Willing to work overseas ?"
                        labelBolder
                        disableCheckBox
                    />
                </span>
                <span className="grid grid-cols-12 mt-1">
                    <div className="col-span-2 text-[1rem]">
                        -แบบประจำ / Permanent
                    </div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            checked={work_abroad?.work_abroad_regularly === accept_enum.NO}
                            label="ไม่ได้"
                            subLabel="No"
                            align="center"
                        />
                    </div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            checked={work_abroad?.work_abroad_regularly === accept_enum.YES}
                            label="ได้"
                            subLabel="Yes"
                            align="center"
                        />
                    </div>
                </span>
                <span className="grid grid-cols-12 mt-1">
                    <div className="col-span-2 text-[1rem]">
                        -แบบชั่วคราว / Temporary
                    </div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            checked={work_abroad?.work_abroad_temporarily === accept_enum.NO}
                            label="ไม่ได้"
                            subLabel="No"
                            align="center"
                        />
                    </div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            checked={work_abroad?.work_abroad_temporarily === accept_enum.YES}
                            label="ได้"
                            subLabel="Yes"
                            align="center"
                        />
                    </div>
                </span>
                <span className="grid grid-cols-12">
                    <div className="col-span-2">
                        <CheckBoxReport
                            label="ท่านสามารถทำงานเป็นกะได้"
                            subLabel="Willing to do shift work ?"
                            labelBolder
                            disableCheckBox
                        />
                    </div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            checked={work_shifts === accept_enum.NO}
                            label="ไม่ได้"
                            subLabel="No"
                            align="center"
                        />
                    </div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            checked={work_shifts === accept_enum.YES}
                            label="ได้"
                            subLabel="Yes"
                            align="center"
                        />
                    </div>
                </span>
                <span className="grid grid-cols-12">
                    <div className="col-span-3">
                        <CheckBoxReport
                            label="กรณีฉุกเฉินบุคคลที่ติดต่อได้"
                            subLabel="Person to be notified in case of emergency ?"
                            labelBolder
                            disableCheckBox
                        />
                    </div>
                    <div className="col-span-9">
                        <DottedLine
                            detail={emergency_data?.emergency_contacts_name || ''}
                            label="แจ้งชื่อ - นามสกุล"
                            defaultLength={220}
                        />
                    </div>
                    <div className="col-span-8">
                        <DottedLine
                            detail={emergency_data?.emergency_contacts_mobile_address || ''}
                            label="ที่อยู่ / Address"
                            defaultLength={210}
                        />
                    </div>
                    <div className="col-span-4">
                        <DottedLine
                            detail={emergency_data?.emergency_contacts_mobile_first || ''}
                            label="โทร./Tel"
                            defaultLength={70}
                        />
                    </div>
                </span>
                <span className="grid grid-cols-12">
                    <div className="col-span-6">
                        <CheckBoxReport
                            label="ท่านเคยบาดเจ็บสาหัสหรือเคยรับการผ่าตัดหรือป่วยในรอบ 5 ปี หรือไม่"
                            subLabel="Any major operation within last 5 years ?"
                            labelBolder
                            disableCheckBox
                        />
                    </div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            checked={serious_injury === accept_enum_two.NEVER}
                            label="ไม่เคย"
                            subLabel="No"
                            align="center"
                        />
                    </div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            checked={serious_injury === accept_enum_two.EVER}
                            label="เคย"
                            subLabel="Yes"
                            align="center"
                        />
                    </div>
                </span>
                <span className="grid grid-cols-12">
                    <div className="col-span-2">
                        <CheckBoxReport
                            label="ท่านมีโรคประจำตัวอะไรบ้าง"
                            subLabel="Healt Issue"
                            labelBolder
                            disableCheckBox
                        />
                    </div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            checked={congenital_disease?.congenital_disease === accept_enum_three.NOT_HAVE}
                            label="ไม่มี"
                            subLabel="No"
                            align="center"
                        />
                    </div>
                    <div className="col-span-2">
                        <CheckBoxReport
                            checked={congenital_disease?.congenital_disease === accept_enum_three.HAVE}
                            label="มี"
                            subLabel="Yes"
                            align="center"
                        />
                    </div>
                    <div className="col-span-12">
                        <DottedLine
                            label="โรคประจำตัว"
                            subLabel="Health Issue"
                            detail={congenital_disease?.congenital_disease_detail ? congenital_disease?.congenital_disease_detail : ''}
                            defaultLength={160}
                        />
                    </div>
                </span>
                <span className="grid grid-cols-18">
                    <div className="col-span-4">
                        <CheckBoxReport
                            label="เคยเป็นพนักงานบริษัทมาก่อน"
                            subLabel="Was Employed here before ?"
                            labelBolder
                            disableCheckBox
                        />
                    </div>
                    <div className="col-span-2 ml-[-2rem]">
                        <CheckBoxReport
                            checked={employee_in_company?.employee_in_company === accept_enum_two.NEVER}
                            label="ไม่เคย"
                            subLabel="No"
                            align="center"
                        />
                    </div>
                    <div className="col-span-3 ml-[3px]">
                        <CheckBoxReport
                            checked={employee_in_company?.employee_in_company === accept_enum_two.EVER}
                            label="เคย"
                            subLabel="Yes"
                            align="center"
                        />
                    </div>
                </span>
                <span className="grid grid-cols-12">
                    <div className="col-span-3">
                        <DottedLine
                            label="ตั้งแต่วันที่"
                            subLabel="From"
                            detail={employee_in_company?.employee_in_company_start ? moment(employee_in_company?.employee_in_company_start).add(543, 'year').format("LL") : ''}
                            defaultLength={67}
                        />
                    </div>
                    <div className="col-span-3 ml-2">
                        <DottedLine
                            label="ถึงวันที่"
                            subLabel="To"
                            detail={employee_in_company?.employee_in_company_end ? moment(employee_in_company?.employee_in_company_end).add(543, 'year').format("LL") : ''}
                            defaultLength={70}
                        />
                    </div>
                </span>
                <span className="grid grid-cols-12">
                    <div className="col-span-3">
                        <DottedLine
                            label="ตำแหน่ง"
                            subLabel="Position"
                            detail={employee_in_company?.employee_in_company_position || ''}
                            defaultLength={70}
                        />
                    </div>
                    <div className="col-span-3 ml-2">
                        <DottedLine
                            label="แผนก"
                            subLabel="Department"
                            detail={employee_in_company?.employee_in_company_department || ''}
                            defaultLength={70}
                        />
                    </div>
                </span>
                <span className="grid grid-cols-18">
                    <div className="col-span-4">
                        <CheckBoxReport
                            label="ท่านมีญาติทำงานที่บริษัทนี้"
                            subLabel="Any relative here ?"
                            labelBolder
                            disableCheckBox
                        />
                    </div>
                    <div className="col-span-2 ml-[-2rem]">
                        <CheckBoxReport
                            checked={relatives_work_company?.relatives_work_company === accept_enum_three.NOT_HAVE}
                            label="ไม่มี"
                            subLabel="No"
                            align="center"
                        />
                    </div>
                    <div className="col-span-3 ml-[3px]">
                        <CheckBoxReport
                            checked={relatives_work_company?.relatives_work_company === accept_enum_three.HAVE}
                            label="มี"
                            subLabel="Yes"
                            align="center"
                        />
                    </div>
                </span>
                <span className="grid grid-cols-12">
                    <div className="col-span-5">
                        <DottedLine
                            label="ชื่อ -สกุล"
                            subLabel="Name-Surname"
                            detail={relatives_work_company?.relatives_work_company_name || ''}
                            defaultLength={124}
                        />
                    </div>
                    <div className="col-span-3 ml-3">
                        <DottedLine
                            label="แผนก"
                            subLabel="Department"
                            detail={relatives_work_company?.relatives_work_company_department || ''}
                            defaultLength={70}
                        />
                    </div>
                    <div className="col-span-12">
                        <DottedLine
                            label="ความสัมพันธ์"
                            subLabel="Relationship"
                            detail={relatives_work_company?.relatives_work_company_relationship || ''}
                            defaultLength={229}
                        />
                    </div>
                </span>
                <span className="grid grid-cols-18">
                    <div className="col-span-4">
                        <CheckBoxReport
                            label="ท่านเคยต้องโทษอาญาหรือไม่"
                            subLabel="Any criminal offense ?"
                            labelBolder
                            disableCheckBox
                        />
                    </div>
                    <div className="col-span-2 ml-[-2rem]">
                        <CheckBoxReport
                            checked={criminal_penalty?.criminal_penalty === accept_enum_two.NEVER}
                            label="ไม่เคย"
                            subLabel="No"
                            align="center"
                        />
                    </div>
                    <div className="col-span-3 ml-[3px]">
                        <CheckBoxReport
                            checked={criminal_penalty?.criminal_penalty === accept_enum_two.EVER}
                            label="เคย"
                            subLabel="Yes"
                            align="center"
                        />
                    </div>
                </span>
                <span className="grid grid-cols-12">
                    <div className="col-span-12">
                        <DottedLine
                            label="เหตุที่ต้องโทษ"
                            subLabel="Offense"
                            detail={criminal_penalty?.criminal_penalty_detail || ''}
                            defaultLength={229}
                        />
                    </div>
                </span>
            </div>
        )
    }

    return (
        <div style={{
            zIndex: "-1",
        }} className="w-screen flex flex-col justify-center items-center">
            {/* PAGE 1 */}
            {detail && (
                <main id="pdf-export-container" className=" w-[8.27in] h-[10.99in] relative mt-[1px] text-[12px] py-7 px-4 bg-white" ref={contentRef}>
                    <ExportData
                        headCells={ExportHeader('1/4')}
                        components={
                            <>
                                <div className="w-full flex items-center">
                                    <div className="flex-1">
                                        {/* <section className="grid grid-cols-12 px-3 pt-2">
                                            <article className="col-span-5">
                                                <DottedLine label="ใบสมัครเลขที่" detail="ฟไกฟawdawdawdawdadawd" defaultLength={80} />
                                            </article>
                                            <article className="col-span-4">
                                                <DottedLine label="วันที่สมัครงาน" detail={detail?.start_date ? moment(detail?.start_date).add(543, 'year').format("LL") : ''} defaultLength={75} />
                                            </article>
                                        </section> */}
                                        {/* <section className="grid grid-cols-12 px-3 mt-[-0.4rem]">
                                            <article className="col-span-5 text-[14px]">
                                                Application No
                                            </article>
                                            <article className="col-span-2 text-[14px]">
                                                Application Date
                                            </article>
                                        </section> */}
                                        <section className="grid grid-cols-12 px-3 pt-2 mt-[-0.4rem]">
                                            <article className="col-span-12">
                                                <DottedLine label="ชื่อ-สกุล(ไทย)" detail={`${detail.first_name || ''} ${detail.last_name || ''}`} defaultLength={213} />
                                            </article>
                                        </section>
                                        <section className="grid grid-cols-12 px-3 mt-[-0.4rem]">
                                            <article className="col-span-12 text-[14px]">
                                                {` Name-Surname (Thai)`}
                                            </article>
                                        </section>
                                        <section className="grid grid-cols-12 px-3 pt-2">
                                            <article className="col-span-12">
                                                <DottedLine label="ชื่อ-สกุล(อังกฤษ)" detail={`${detail.first_name_eng || ''} ${detail.last_name_eng || ''}`} defaultLength={207} />
                                            </article>
                                        </section>
                                        <section className="grid grid-cols-12 px-3 mt-[-0.4rem]">
                                            <article className="col-span-12 text-[14px]">
                                                {` Name-Surname (English)`}
                                            </article>
                                        </section>
                                    </div>
                                    <div className="h-full flex justify-start border-2 items-center">
                                        {fileImagePath && (
                                            <span className="w-[96px] h-[96px] flex justify-center">
                                                <img className="object-cover" width={96} height={96} src={api_path + "/" + fileImagePath} alt="profile" />
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <section className="grid grid-cols-12">
                                    {PositionData()}
                                </section>
                                {/* <section className="grid grid-cols-12 mt-2">
                                    {PersonnelInformationData()}
                                </section> */}
                                <section className="grid grid-cols-12 mt-2">
                                    {AddressData(detail?.address || [])}
                                </section>

                                <section className="grid grid-cols-12 mt-2">
                                    {EmploymentHistoryData(detail?.work_history || [])}
                                </section>
                                <section className="grid grid-cols-12">
                                    {EducationData(detail.education?.education_data || [])}
                                </section>
                                <section className="grid grid-cols-12 mt-2">
                                    {traningData(detail.training?.training_data || [])}
                                </section>
                                <section className="grid grid-cols-12 mt-2">
                                    {languageData(detail.additional_information?.language_proficiency || [])}
                                </section>
                                <section className="grid grid-cols-12 mt-2">
                                    {otherAbilityData(detail.additional_information?.other_abilities || [])}
                                </section>
                            </>

                        }
                    />
                </main>
            )}

            {/* PAGE 2 */}
            {/* {detail && (
                <main id="pdf-export-container" className=" w-[8.27in] h-[10.99in] relative mt-[1px] text-[12px] py-7 px-4 bg-white" ref={contentRef}>
                    <ExportData
                        headCells={ExportHeader('2/4')}
                        components={
                            <>
                                <section className="grid grid-cols-12">
                                    {parentData()}
                                </section>
                                <section className="grid grid-cols-12 mt-2">
                                    {siblingsData(detail?.siblings || [])}
                                </section>
                                <section className="grid grid-cols-12 mt-2">
                                    {EmploymentHistoryData(detail?.work_history || [])}
                                </section>
                            </>

                        }
                    />
                </main>
            )} */}
            {/* PAGE 3 */}
            {/* {detail && (
                <main id="pdf-export-container" className=" w-[8.27in] h-[10.99in] relative mt-[1rem] text-[12px] py-7 px-4 bg-white" ref={contentRef}>
                    <ExportData
                        headCells={ExportHeader('3/4')}
                        components={
                            <>
                                <section className="grid grid-cols-12">
                                    {EducationData(detail.education?.education_data || [])}
                                </section>
                                <section className="grid grid-cols-12 mt-2">
                                    {traningData(detail.training?.training_data || [])}
                                </section>
                                <section className="grid grid-cols-12 mt-2">
                                    {languageData(detail.additional_information?.language_proficiency || [])}
                                </section>
                                <section className="grid grid-cols-12 mt-2">
                                    {otherAbilityData(detail.additional_information?.other_abilities || [])}
                                </section>
                            </>

                        }
                    />
                </main>
            )} */}
            {/* PAGE 4 */}
            {/* {detail && (
                <main id="pdf-export-container" className=" w-[8.27in] h-[10.99in] relative mt-[1rem] text-[12px] py-7 px-4 bg-white" ref={contentRef}>
                    <ExportData
                        headCells={ExportHeader('4/4')}
                        components={
                            <div className="border-[1px] border-black p-2">
                                <section className="grid grid-cols-12">
                                    {additionalInformation(detail?.additional_information || null, detail || null)}
                                </section>
                                <section className="grid grid-cols-12 mt-2">
                                </section>
                            </div>
                        }
                    />
                </main>
            )} */}
        </div>
    );
};

export default FormPersonnelExport;


export function ExportData(props: ExportProps) {
    return (
        <>
            <div className="large mb-2">{props.headCells}</div>
            {props.components}
        </>
    );
}